module.exports = __webpack_public_path__ + "img/algolia-search.57103ac6.svg";